var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentValidation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.213 25.2138H12.0005C7.42415 25.2138 5.13542 25.2138 3.71313 23.8706C2.29198 22.5285 2.29199 20.367 2.29199 16.0451V11.4608C2.29199 7.1389 2.29198 4.97739 3.71313 3.63532C5.13542 2.29211 7.42415 2.29211 12.0005 2.29211H18.3372C18.5205 2.29211 18.7005 2.30243 18.8781 2.32421C15.998 2.62563 13.7528 5.0622 13.7528 8.02254C13.7528 11.1869 16.3189 13.753 19.4833 13.753C20.7737 13.753 21.9634 13.3266 22.9215 12.6069V16.5242C22.9192 20.5286 22.8677 22.579 21.5004 23.8706C20.0781 25.2138 17.7893 25.2138 13.213 25.2138Z",
    fill: "url(#paint0_linear_4930_7622)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01345 25.9012C7.87698 26.0101 10.5313 26.0742 13.0653 26.0742L13.0687 26.072C15.3723 26.072 17.5763 26.0181 18.9963 25.8977C20.1366 25.829 23.1325 24.935 23.5153 21.6378C23.8266 18.9584 23.8053 17.0026 23.7973 16.2633L23.7972 16.2603C23.7961 16.1778 23.7961 16.1102 23.7961 16.0609C23.7961 15.5864 23.411 15.2013 22.9365 15.2013C22.462 15.2013 22.0769 15.5864 22.0769 16.0609C22.0769 16.085 22.0774 16.1126 22.0779 16.1437C22.0785 16.1835 22.0792 16.2289 22.0792 16.2798L22.0794 16.3022C22.0865 17.026 22.1047 18.8921 21.8076 21.4406C21.5085 24.009 18.9126 24.1832 18.8862 24.1844C18.8782 24.1855 18.869 24.1867 18.861 24.1867C15.9534 24.4365 9.62243 24.3907 6.11541 24.1855C3.66508 24.0434 3.16424 21.114 3.16424 20.3369V20.3255C3.14476 18.87 3.15048 15.952 3.15736 12.8622C3.1608 11.2302 3.16424 9.54426 3.16424 7.98215C3.16424 4.37428 4.94415 3.48951 6.43864 3.38293C6.45354 3.38178 6.46728 3.38063 6.48218 3.37834C6.50854 3.3749 9.12277 3.05972 11.8825 3.17548C12.3593 3.19496 12.7582 2.82708 12.7776 2.3526C12.7971 1.87812 12.4292 1.47698 11.9547 1.4575C9.15714 1.3406 6.57614 1.6363 6.2942 1.66954C4.8169 1.78071 1.444 2.6242 1.444 7.98215C1.444 9.54312 1.44055 11.2279 1.43711 12.8587C1.43024 15.9509 1.42451 18.8723 1.444 20.3427C1.44514 21.1575 1.68237 22.432 2.3471 23.57C3.18488 25.0038 4.45248 25.8106 6.01345 25.9012Z",
    fill: "url(#paint1_linear_4930_7622)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.336 10.6011C18.3214 10.6011 18.3069 10.601 18.2924 10.5999C17.9829 10.5839 17.7067 10.4028 17.5681 10.1266C17.3194 9.62919 17.1154 9.48018 17.0569 9.4458C16.6455 9.38162 16.3303 9.02634 16.3303 8.59656C16.3303 8.12208 16.7154 7.737 17.1899 7.737C17.3618 7.737 17.8179 7.78858 18.3256 8.26421C19.0671 7.28889 20.274 5.92388 21.4877 5.4941C21.9358 5.33594 22.4263 5.56975 22.5845 6.01787C22.7426 6.46484 22.5089 6.95652 22.0607 7.11468C21.0889 7.45851 19.7055 9.19253 19.0614 10.2034C18.9032 10.4521 18.6294 10.6011 18.336 10.6011Z",
    fill: "url(#paint2_linear_4930_7622)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4832 14.6122C15.8489 14.6122 12.8932 11.6565 12.8932 8.02224C12.8932 4.38801 15.8489 1.43226 19.4832 1.43226C23.1174 1.43226 26.0732 4.38801 26.0732 8.02224C26.0732 11.6565 23.1174 14.6122 19.4832 14.6122ZM19.4832 3.15138C16.7979 3.15138 14.6123 5.33697 14.6123 8.02224C14.6123 10.7075 16.7979 12.8931 19.4832 12.8931C22.1684 12.8931 24.354 10.7075 24.354 8.02224C24.354 5.33697 22.1684 3.15138 19.4832 3.15138Z",
    fill: "url(#paint3_linear_4930_7622)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6067 15.7583H8.02233C7.54785 15.7583 7.16276 15.3732 7.16276 14.8987C7.16276 14.4243 7.54785 14.0392 8.02233 14.0392H12.6067C13.0811 14.0392 13.4662 14.4243 13.4662 14.8987C13.4662 15.3732 13.0811 15.7583 12.6067 15.7583Z",
    fill: "url(#paint4_linear_4930_7622)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02233 20.3426H17.191C17.6655 20.3426 18.0506 19.9576 18.0506 19.4831C18.0506 19.0086 17.6655 18.6235 17.191 18.6235H8.02233C7.54785 18.6235 7.16276 19.0086 7.16276 19.4831C7.16276 19.9576 7.54785 20.3426 8.02233 20.3426Z",
    fill: "url(#paint5_linear_4930_7622)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4930_7622",
    x1: 12.6068,
    y1: 2.29211,
    x2: 12.6068,
    y2: 25.2138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4930_7622",
    x1: 13.7519,
    y1: 1.4303,
    x2: 13.7519,
    y2: 26.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4930_7622",
    x1: 13.7519,
    y1: 1.4303,
    x2: 13.7519,
    y2: 26.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4930_7622",
    x1: 13.7519,
    y1: 1.4303,
    x2: 13.7519,
    y2: 26.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4930_7622",
    x1: 13.7519,
    y1: 1.4303,
    x2: 13.7519,
    y2: 26.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4930_7622",
    x1: 13.7519,
    y1: 1.4303,
    x2: 13.7519,
    y2: 26.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentValidation);
export default __webpack_public_path__ + "static/media/document-validation.d7d4608f0ec1e812ca979b4de9238715.svg";
export { ForwardRef as ReactComponent };